import { ReactElement } from 'react';

import { Loader } from '@calm-web/design-system';

import AltProgramLayout from '@/components/app/program/AltProgramLayout';
import ProgramLayout from '@/components/app/program/ProgramLayout';
import ProgramLayoutV2 from '@/components/app/programV2/ProgramLayout';
import { useProgramState } from '@/hooks/store';
import { useAmplitudeExperiment } from '@/hooks/utils/experiments/useAmplitudeExperiment';
import { AmplitudeExperimentNames } from '@/utils/experiments/amplitudeExperiment';

export default function ProgramComponent(): ReactElement {
	const program = useProgramState();
	const { isEnrolled, isLoading } = useAmplitudeExperiment(AmplitudeExperimentNames.WEB_APP_REDESIGN_2);

	if (isLoading) {
		return <Loader />;
	}

	if (isEnrolled) {
		return <ProgramLayoutV2 />;
	}

	if (program && ['masterclass', 'body'].includes(program.meditation_type)) {
		return <AltProgramLayout program={program} />;
	}

	return <ProgramLayout program={program} />;
}
